import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.heading',
		defaultMessage: 'Invite users to your project',
		description: 'Title of user email mapping table',
	},
	user: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.user',
		defaultMessage: 'User',
		description: 'Title of user row in user email mapping table',
	},
	email: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.email',
		defaultMessage: 'Email',
		description: 'Title of email row in user email mapping table',
	},
	back: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.back',
		defaultMessage: 'Back',
		description: 'Button text to return to previous import step',
	},
	tryAgain: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.try-again',
		defaultMessage: 'Try again',
		description: 'Button text to continue next import step',
	},
	textFieldPlaceholder: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.text-field-placeholder',
		defaultMessage: 'e.g., name@company.com',
		description: 'Placeholder text for email text field',
	},
	error: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.error',
		defaultMessage: "We couldn't find the user details",
		description: 'Heading for error page when an error occurred getting the user details',
	},
	noUsers: {
		id: 'project-create-importer-upload-flow.user-mapping-screen.no-users',
		defaultMessage: 'There are no users in your selected board.',
		description: 'Message shown when there are no users to map',
	},
});
